;(function () {
  'use strict'

  angular
    .module('contrast.score-settings.all-option')
    .constant('SCORE_SETTINGS_ALL_OPTION', {
      name: 'All languages',
      display: 'All languages',
      value: 'all'
    })
})()
